<template>
  <div class="table-responsive">
    <div class="container-table">
      <table class="table table-striped- table-bordered table-hover table-checkable">
        <thead>
          <tr>
            <td nowrap class="text-center align-middle" width="100">Valor</td>
            <td nowrap class="text-center align-middle" width="100">Tipo</td>
            <td nowrap class="text-center align-middle" width="100">Status</td>
            <td nowrap class="text-center align-middle" width="100">Expiração</td>
            <td nowrap class="text-center align-middle" width="100">Produto</td>
            <td nowrap class="text-center align-middle" width="40">Motivo</td>
            <td nowrap class="text-center align-middle" width="40">Ações</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(discount, id) in data" :key="id">
            <td class="text-center align-middle" v-if="discount.is_percentage === 2">
              {{ discount.amount }}%
            </td>
            <td class="text-center align-middle" v-if="discount.is_percentage === 1">
              {{ discount.amount | money }}
            </td>
            <td class="text-center align-middle">
              {{ discount.discount_type === 1 ? 'Saldo' : 'Único' }}
            </td>
            <td class="text-center align-middle">
              {{
                discount.status === 2 ? 'Utilizado' : discount.is_expired ? 'Expirado' : 'Pendente'
              }}
            </td>
            <td class="text-center align-middle">{{ discount.until_date | month }}</td>
            <td class="text-center align-middle">
              {{ discount.product ? discount.product.name : '-' }}
            </td>
            <td class="text-center align-middle">
              <i
                class="fa fa-exclamation-circle"
                v-b-tooltip.hover
                :title="discount.reason ? discount.reason.reason : '-'"
              ></i>
            </td>
            <td class="text-center align-middle">
              <a
                href=""
                @click.prevent.stop="confirmDel(discount.id)"
                class="icon-circle"
                :class="{ disabled: discount.status > 1 }"
                v-b-tooltip.hover
                title="Excluir desconto"
              >
                <i class="fas fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'DiscountCompany',
  components: {},
  props: {
    customerId: Number,
  },
  data() {
    return {
      data: {},
      filters: {
        id: localStorage.customerFilterId ? localStorage.customerFilterId : '',
      },
    };
  },
  methods: {
    setStorageFilters() {
      localStorage.setItem('customerFilterId', this.filters.id);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }`;
      return filters;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      this.getCustomersPendingDiscounts();
    },
    getCustomersPendingDiscounts() {
      const url = `${baseApiUrl}/v1/customer/${this.customerId}/pending-discounts`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir esse desconto?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.del(id);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> O desconto não foi excluído!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/customer/${this.customerId}/discounts/delete/${id}`;
      axios
        .delete(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
